/**
 * TODO
 * Moved from login widget but those constants
 * should be in commons-general for instance.
 */

const CONSTANT = {
    QUOTE_STATUS: {
        ACTIVE: 0,
        EXPIRED: 1,
        SOLD_WITH_DEPOSIT: 4352,
        CREDIT_APPROBATION: 200960,
        F_N_I: 69888,
        CONGRATULATIONS: 3346688,
        DELIVERED_TRIAL_PERIOD: 5443840,
        DELIVERED: 1249536,
        DELIVERED_CANCELED: 5443841,
    },
};

export default CONSTANT;



// WEBPACK FOOTER //
// ./src/constants/constant.js